import React, {Fragment} from 'react';
import {Helmet} from 'react-helmet';
import Footer from "../../components/Footer";
import BreadCrumb from "../../components/BreadCrumb";
import CTA from "../../components/CTA";
import HowItWorks from "../../components/HowItWorks";
import {Grid} from '@material-ui/core';

import './style.scss';

const Guide =() => {
    return(
        <Fragment>
            <Helmet>
            <title>One Two Pay Guide</title>
            <meta name="description" content="Todos!" />
            </Helmet>
            <BreadCrumb
                pagename="Guide"
                title="How it all works"
            />
           <HowItWorks />
           <Grid
                container
                spacing={4}
                alignItems="center"
                className="container"
            >
                <Grid item xs={12}>
                    <Grid className="introList2"> 
                        <h1> One</h1>
                        <p>

                            Once you find yourself on the “Create Pay Stub” page, you’re ready to go. Kick-off the process by entering the name of the business or employer, the employee for whom you’re making the pay stub, the employee address (we highly suggest you add this now), and the employee ID, and the province or territory of employment. <br/>
                            <b>Note: </b> the employee ID is not mandatory.<br/><br/>

                            Next, you’ll drop in the payment information. Go ahead and select the pay period frequency as per your payment process. Next, you’ll note if there is or is not an extra period. <br/><br/>

                            Here’s what that means: If your Pay Period Frequency is Weekly or Bi-Weekly, you might have 53 (weekly) or 27 (bi-weekly) pay periods in some calendar years instead of the usual 52 and 26. If you think you’ll be paying 53 or 27 times in the current calendar year, select yes to the extra period.<br/><br/>

                            Finally, you’ll choose your pay period start and end dates.
                            Note: A pay period is the recurring amount of time which work hours are recorded and paid out. Examples include: bi-weekly (every two weeks), semi-monthly (at the middle and end of each month, for example), and monthly. Put simply, it’s how often an employee gets paid. <br/><br/>

                            OneTwoPay will automatically generate an estimated start and end date to help you out. Be sure to double-check that it matches your records. <br/><br/>

                            Congrats, step one is complete. Hit that “Next” button. <br/><br/>

                        </p>

                        <h1> Two </h1>
                        <p>
                            Now, onto the income for the current period that you just outlined in step ONE. <br/><br/>

                            Use the toggle button right at the top to select “hourly” or “fixed” income and add the regular income amount. 
                            If you have another type of income (Overtime, bonus, vacation, stat/holiday) you can hit the blue + on the top right or the ‘add another income type” link right below. <br/><br/>

                            <b>Note:</b> A circumstance when you might want to add an additional income type would be a pay stub that has both regular and vacation pay on one stub. 


                            Add in any taxable benefits for the current pay period. <br/><br/>

                            Here’s what that means: Taxable benefits include any payments or provisions to an employee, employee's family or another non-arms-length person. For more information on taxable benefits, visit the <a href="https://www.canada.ca/en/revenue-agency/services/tax/businesses/topics/payroll/benefits-allowances.html"> CRA Benefits and Allowances page.</a><br/><br/>
                            Note: This is not a mandatory field. Don’t worry about it if it’s not applicable to your pay stub. <br/><br/>


                            Add your Year To Date income and deductions. <br/><br/>

                            Here’s what that means: Have you already paid this employee in the current year? Use this area to enter the sum of all income and deductions from previous periods. Do not include current period income here. It will be added in for you. Note that CPP and EI deductions require associated minimum income amounts.<br/><br/>

                            Note: This is not mandatory but we highly recommend that you don’t skip this step. Unless you are creating the first pay stub for the employee for the current year, there should be previous period income. If you don’t enter this amount, the Year-To-Date amounts on the pay stub will be incorrect and all subsequent pay stub for this employee will also be incorrect.. You only need to do this on the first pay stub for each employee and OneTwoPay will fill these values in on subsequent pay stubs.<br/><br/>


                            Next, move onto the “personal tax credits” section and select your Federal Claim Code and Provincial Claim Code. Your options will automatically change based on the province and gross income you’ve already entered. <br/><br/>

                            Check the CPP and EI exemption boxes if your employee is exempt from the CPP and EI programs. As an example, employees under 18 do not pay CPP.<br/><br/>

                            Enter your Employer EI Premium Rate (it’s likely 1.4 which is pre-loaded in this box).<br/><br/>

                            More info: This is not the Employee EI Premium Rate which usually changes each year. The employer's EI premium rate is equal to 1.4 times the employee's premium, unless a reduced rate applies. If a reduced rate applies, enter the rate in this field. If you would like to learn more about EI, please visit the CRA Employment Insurance Page.<br/><br/>
                            You did it. Hit that “Next’ button.  <br/><br/>
                        </p>

                        <h1> Pay</h1>
                        <p>                       
                            You’re ready to check out your pay stub. If you need to change anything, you can just click the Edit General Info link or the Edit Income link.<br/><br/>

                            If you want to add an employee address and didn’t before, you can go back and do that now.<br/><br/>


                            Add your logo (if you or your company has one). You’ll need a PNG, JPEG, or JPG file. <br/>
                            Note: This is not mandatory.<br/><br/>


                            Do you want to add additional deductions or deduct something different from what the CRA is calculating?? Click “override calculations” and change whatever you desire. <br/><br/>


                            Take a scan of your pay stub and your remittance summary, make sure everything checks out, and hit the “finalize pay stub” button at the top.<br/><br/> 

                            <b>Boom, you’re done. Now that you’ve got your pay stub, it’s time to pay us. Unless you’ve already got a membership or a pay-as-you-go plan, of course. See you next time.</b>  <br/><br/>

                        </p>
                    </Grid>
                </Grid>
            </Grid>    
            <CTA/>
            <Footer/>
        </Fragment>
    )
};
export default Guide;